<template>
  <v-layout wrap>
    <v-flex xs12>
      <v-autocomplete
        multiple box clearable
        v-model="selectedMultipleChips"
        :disabled="readonly"
        :items="items"
        label="Select field multiple label"
        no-data-text="No results"
        append-icon="keyboard_arrow_down"
        item-text="name"
        clear-icon="cancel"
        item-value="name">
        <template slot="selection" slot-scope="data">
          <v-chip
            :selected="data.selected"
            close class="white--text"
            @input="remove(data.item)"
            color="secondary">
            {{ data.item.name }}
          </v-chip>
        </template>
      </v-autocomplete>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'multi-select-field-chips',
  props: {
    field: {
      type: Object
    },
    data: {
      type: String
    },
    embedded: {
      type: Boolean,
      default: false
    },
    row: {
      type: Number
    }
  },
  computed: {
    items() {
      let opts = []
      if (this.field) { if (this.field.options) { opts = this.field.options } }
      return opts
    },
    selectedMultipleChips: {
      get() {
        if (this.data) {
          return this.data
        } else {
          if (this.field && this.field.default_value) {
            return this.field.default_value
          } else {
            return ""
          }
        }
      },
      set(value) {
        this.$emit('update-item', { field: this.field.name, data: value, row: this.row })
      }
    },
    readonly() {
      let readonly = false
      if (this.field && this.field.readonly) { readonly = this.field.readonly }
      return readonly
    }
  },
  methods: {
    remove(item) {
      const index = this.selectedMultipleChips.indexOf(item.name)
      if (index >= 0) this.selectedMultipleChips.splice(index, 1)
    }
  }
}
</script>
